export default "__VITE_ASSET__BD0322LL__"